module.exports = __webpack_public_path__ + "img/sencilla-2.7ae79070.jpg";